import Ajax from 'global/od/Ajax';

export const getBrands = data => getData('/ink-toner-finder/ajax/brands', data);
export const getSeries = data =>
	getData('/ink-toner-finder/ajax/device/model-series-by-brand', data);
export const getModels = data =>
	getData('/ink-toner-finder/ajax/devices', data);

export const deleteSelectedPrinter = deviceId =>
	deleteData(`/ink-toner-finder/ajax/user-selected-devices/${deviceId}/delete`);

const getData = (url, data = {}) =>
	Ajax({
		url,
		method: 'GET',
		dataType: 'json',
		data,
	});

const deleteData = url =>
	Ajax({
		url,
		method: 'POST',
		dataType: 'json',
	});
